import React from "react";
import "./index.scss";
import culture1 from "../../../assets/images/aboutUs/culture1.png";
import { useTranslation } from "react-i18next";
function Culture() {
  const { t } = useTranslation();
  const cultureContent = t("home.anchorPoint3Con", { returnObjects: true });
  return (
    <div className="home_culture_" id="home_culture_id">
      <div className="home_culture_edition">
        <div className="edition_solution edition_solution_top">
          <div className="edition_solution_title">
            <div>{t("home.anchorPoint3")}</div>
            <span>{cultureContent.detail}</span>
          </div>
        </div>
        <div className="home_culture_con_top">
          {cultureContent.contentList.map((item, index) => {
            return (
              <div className="top_top" key={index}>
                <div className="top_img"></div>
                <div className="top_tit">{item.tit}</div>
                <div className="top_con">{item.con}</div>
              </div>
            );
          })}
        </div>
        <div className="home_culture_con">
          {/* <div className="home_culture_con_bg">
            <img src={culture1} alt="" />
          </div> */}
          <div className="home_culture_content">
            {cultureContent.footList.map((item, index) => {
              return (
                <div key={index}>
                  <p>{item.tit}</p>
                  {item.con}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Culture;
